import ReactDOM from 'react-dom';
import React, { Component } from 'react';

class Modal extends React.Component {
  constructor(props) {
    // console.log('Modal constructor');
    super(props);
    this.el = document.createElement('div');
    this.el.setAttribute('id', 'modal_content');
  }

  onclose = () => {
    //   modal_content
    // var body = document.body;
    // var childTobeRemoved = document.getElementById('modal_content');
    // document.getElementById('user_modal').removeChild(childTobeRemoved);
    document.getElementById('app').style.display = 'block';
    this.componentWillUnmount();
  };

  componentDidMount() {
    // console.log('Modal componentDidMount');
    document.getElementById('user_modal').appendChild(this.el);
    document.getElementById('app').style.display = 'none';
    document
      .getElementsByClassName('custom_close')[0]
      .addEventListener('click', this.onclose);
  }

  //   componentWillReceiveProps(nextp)

  componentWillUnmount() {
    // console.log('Modal componentWillUnmount');
    document.getElementById('user_modal').removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
export default Modal;



// WEBPACK FOOTER //
// ./components/popupContents/modal.js